<!-- Header -->
<!--<nav class="navbar navbar-expand-lg p-0 navbar-light bg-light position-absolute text-white w-100">
    <div class="border-bottom container px-0 py-4">
        <a class="navbar-brand" href="#">
            <img src="assets/images/logo/logo.png" class="nav-logo" alt="">
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse justify-content-between" id="navbarText">
            <span>
                Descrubrí los colores de tu destino
            </span>
            <ul class="navbar-nav mr-auto text-white">
                <li class="nav-item active">
                    <a class="text-white rounded-pill border border-2 me-3 border-light nav-link btn-md btn-outline" href="#" data-bs-toggle="modal" data-bs-target="#login">Iniciar Sesión</a>
                </li>
                <li class="nav-item">
                    <a class="text-white rounded-pill border border-2 border-light nav-link btn-md btn-outline" data-bs-toggle="modal" data-bs-target="#login" href="#">Registrarme</a>
                </li>
            </ul>
        </div>
    </div>
</nav> -->

<nav class="navbar navbar-expand-lg navbar-dark text-white position-absolute w-100">
    <div class="container border-bottom px-0 py-lg-2 py-0">
      <a class="navbar-brand ms-3 ms-lg-0" href="">
          <img src="assets/images/logo/logo.png" class="nav-logo" alt="">
      </a>
      <button style="cursor: pointer;"  class="navbar-toggler me-3 me-lg-0" type="button"  aria-controls="navbarContent" [attr.aria-expanded]="!collapsed" aria-label="Toggle navigation" (click)="collapsed = !collapsed">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="navbar-collapse justify-content-between px-3 px-lg-0" [class.collapse]="collapsed" id="navbarContent">
          <span class="navbar-text text-white pb-lg-0 pb-4 d-none d-md-block">
              Descrubrí los colores de tu destino
          </span>
        <ul class="navbar-nav mb-2 mb-lg-0 pt-3 pt-lg-0 flex-row justify-content-center">
          <li class="nav-item">
              <a style="cursor: pointer;"  class="text-white rounded-pill border border-2 me-3 border-light nav-link btn-md btn-outline" (click)="openLogin()">Iniciar Sesión</a>
          </li>
          <li class="nav-item">
              <a style="cursor: pointer;"  class="text-white rounded-pill border border-2 border-light nav-link btn-md btn-outline" (click)="openRegister()">Registrarme</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  
